import { createFileRoute, useSearch } from "@tanstack/react-router";
import ReservasPage from "@/components/ReservasPage";
import Sidebar from "@/components/Sidebar";
import { useMediaQuery } from "@/hooks/use-media-query";

export type ReservasView = "table" | "timeline" | "dashboard";

export interface ReservasSearch {
  view?: ReservasView;
  date?: string;
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const VIEWS: ReadonlySet<ReservasView> = new Set(["table", "timeline", "dashboard"]);

// Mobile default is the Sidebar (compact list designed for the host's
// phone). An explicit ?view= deep-link opens ReservasPage on mobile too
// so timeline / table / dashboard remain reachable via shareable URLs.
// The arbitrary selector hides the Sidebar's lg:hidden close button —
// it belongs to the Sheet overlay and has no use when the Sidebar IS
// the page.
function ReservasRoute() {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const search = useSearch({ from: "/reservas" });
  if (isDesktop || search.view) return <ReservasPage />;
  return (
    <div className="flex-1 min-h-0 [&>aside>div:first-child>button:first-child]:hidden">
      <Sidebar />
    </div>
  );
}

export const Route = createFileRoute("/reservas")({
  validateSearch: (search: Record<string, unknown>): ReservasSearch => {
    const view =
      typeof search.view === "string" && VIEWS.has(search.view as ReservasView)
        ? (search.view as ReservasView)
        : undefined;
    const date =
      typeof search.date === "string" && DATE_RE.test(search.date) ? search.date : undefined;
    return { view, date };
  },
  component: ReservasRoute,
});
